/**
 * @desc 获取主体信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.OrderCompanyRpcResponseDto>>;
export function request(
  body: defs.basics.OrderCompanyRpcRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/ordercompany/getList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
